<div>
  <div
    v-if="shouldRenderConfig"
    v-show="alwaysShow || getShowUpload"
    v-bind:class="[getClassName, getAttribute('statusUploaded') ? getClassName + 'Uploaded' : '', getAttribute('isLoading') ? getClassName + 'IsLoading' : '']"
  >
    <div :class="getClassName + 'HeaderContainer'">
      <div :class="getClassName + 'Header'">{{ $t('Upload Your ')}} {{ propsData.label }} {{ $t('Artwork') }}</div>
    </div>
    <div :class="getAttribute('isLoading') ? getClassName + 'IsLoadingText' : ''" v-if="!getProductPartUploadedFileName(propsData.code)">{{ $t('Upload now, or in Your Account section after checkout') }}</div>
    <appUploadDropzone :propsData="propsData"></appUploadDropzone>
    <div v-bind:class="getClassName + 'LoadingContainer'" v-show="getAttribute('isLoading')">
      <ProgressBar :value="getAttribute('loadingProgress')"  style="width:100%"></ProgressBar>
      <div v-bind:class="getClassName + 'LoadingValue'" >
        {{parseInt(getAttribute('loadingProgress')) + " %"}}
      </div>
    </div>
    <div v-bind:class="getClassName + 'Preview'" v-if="getAttribute('statusUploaded') && !getIsMobile && !getIsMyAccount">
      <appUploadPreview 
        :propsData="propsData" :useClassName="getClassName + 'PreviewContainer'"
        v-if="getShowPreviewInUpload && getAttribute('previewFile')">
      </appUploadPreview>
      <div v-bind:class="[getClassName + 'StatusContainer', getIsPreflightCheckLoadingForProductPart() ? 'loadingPreflight' : '']">
        <div :class="getClassName + 'StatusContainerHeader'">
          <div :class="getClassName + 'StatusContainerTitle'">
            {{ propsData.label }} {{ $t('Artwork File')}}
          </div>
          <div :class="getClassName + 'StatusContainerFileName'">
            {{ getProductPartUploadedFileName(propsData.code) }}
          </div>
        </div>
        <appUploadPreflight  :uploadedFileData="uploadedFileData" :propsData="propsData" :useClassName="getClassName + 'PreflightContainer'"></appUploadPreflight>
        <!-- <appUploadActions :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions> -->
      </div>
      <div v-if="!getIsPreflightCheckLoadingForProductPart()" :class="getClassName + 'ActionButtons'">
        <appUploadActions :uploadedFileData="uploadedFileData" :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions>
      </div>
    </div>
    <div v-bind:class="getClassName + 'Preview'" v-else-if="getAttribute('statusUploaded') && getIsMobile">
      <div v-bind:class="[getClassName + 'StatusContainer', getClassName + 'StatusContainerMobile']">
        <div :class="getClassName + 'StatusContainerHeader'">
          <div :class="getClassName + 'StatusContainerTitle'">
            {{ propsData.label }} {{ $t('Artwork File')}}
          </div>
          <div :class="getClassName + 'StatusContainerFileName'">
            {{ getProductPartUploadedFileName(propsData.code) }}
          </div>
        </div>
        <appUploadPreflight :uploadedFileData="uploadedFileData" :propsData="propsData" :useClassName="getClassName + 'PreflightContainer'"></appUploadPreflight>
        <!-- <appUploadActions :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions> -->
      </div>
      <div :class="getClassName + 'MobilePreviewActionsContainer'">
        <appUploadPreview 
          :propsData="propsData" :useClassName="getClassName + 'PreviewContainer'"
          v-if="getShowPreviewInUpload && getAttribute('previewFile')">
        </appUploadPreview>
        <div :class="getClassName + 'ActionButtons'">
          <appUploadActions v-if="!getIsPreflightCheckLoadingForProductPart()" :uploadedFileData="uploadedFileData" :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions>
        </div>
      </div>
    </div>
    <div v-bind:class="getClassName + 'Preview'" v-else-if="getAttribute('statusUploaded') && getIsMyAccount">
      <div v-bind:class="[getClassName + 'StatusContainer', getClassName + 'StatusContainerMobile']">
        <div :class="getClassName + 'StatusContainerHeader'">
          <div :class="getClassName + 'StatusContainerTitle'">
            {{ propsData.label }} {{ $t('Artwork File')}}
          </div>
          <div :class="getClassName + 'StatusContainerFileName'">
            {{ getProductPartUploadedFileName(propsData.code) }}
          </div>
        </div>
        <appUploadPreflight :uploadedFileData="uploadedFileData" :propsData="propsData" :useClassName="getClassName + 'PreflightContainer'"></appUploadPreflight>
        <!-- <appUploadActions :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions> -->
      </div>
      <div :class="getClassName + 'MobilePreviewActionsContainer'">
        <appUploadPreview 
          :propsData="propsData" :useClassName="getClassName + 'PreviewContainer'"
          v-if="getShowPreviewInUpload && getAttribute('previewFile')">
        </appUploadPreview>
        <div :class="getClassName + 'ActionButtons'">
          <appUploadActions v-if="!getIsPreflightCheckLoadingForProductPart()" :areLinksExpired="getAreLinksExpired()" :uploadedFileData="uploadedFileData" :propsData="propsData" :useClassName="getClassName + 'ActionsContainer'"></appUploadActions>
        </div>
      </div>
    </div>
  </div>
  <div v-if="!getProductPartUploadedFileName(propsData.code)" :class="[getClassName + 'DownloadCreateButtons', getAttribute('isLoading') ? getClassName + 'IsLoadingDownloadCreateButtons' : '']">
    <appDownloadTemplateButton :ppCode="propsData.code"></appDownloadTemplateButton>
    <!-- <appPersonalizationButton></appPersonalizationButton> -->
    <!-- <appCreateArtworkButton></appCreateArtworkButton> -->
  </div>
</div>
